/* eslint-disable no-unused-vars */
import { teal } from "@mui/material/colors";
import { Card, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PoleDisplayUtils } from "../../utils/PoleDisplayUtils";
import { PricingUtils } from "../../utils/PricingUtils";

export default function SaleSummary(props) {
  const { t } = useTranslation();
  const translate = t;
  const [total, setTotal] = useState("0");
  const [totalWithoutRounding, setTotalWithoutRounding] = useState("0");
  const [totalAfterSubtotalDiscount, setTotalAfterSubTotalDIscount] =
    useState(0);
  //const [currency, setCurrency] = useState("AED");
  //const [decimal, setDecimal] = useState("2");
  const [noItems, setNoItems] = useState("0");
  const [qty, setQty] = useState("0");
  const [qtyInBaseUnit, setQtyInBaseUnit] = useState("0");
  const [tax, setTax] = useState("0");
  const [discount, setDiscount] = useState("0");
  const [amountExTax, setAmountExTax] = useState("0");
  const [subTotalDiscount, setSubtotalDiscount] = useState(0.0);

  props.biRef.saleSummary = {
    parentEvent: parentEvent,
  };

  function parentEvent(event, value1, value2, value3) {
    if (event === "getTotalAmount") {
      return total;
    } else if (event === "updateTotalAfterDiscount") {
      setSubtotalDiscount(
        PricingUtils.formattedNumber(
          parseFloat(total) - parseFloat(value1),
          props.context.store.currencyDecimal
        )
      );
      setTotalAfterSubTotalDIscount(value1);
    }
  }

  useEffect(() => {
    setSubtotalDiscount(0);
    let total = 0;
    let noItems = 0;
    let qty = 0;
    let qtyInBaseUnit = 0;
    let tax = 0;
    let discount = 0;
    let amountExTax = 0;
    let itemsSet = new Set();
    let selectedRow = null;
    for (let d of props.data) {
      if (d[9].info.selected == true) {
        selectedRow = d;
      }
      if (!d[9].info.returnFlag) {
        itemsSet.add(d[9].info.key);
        qty = qty + parseFloat(d[5].v);
        qtyInBaseUnit =
          qtyInBaseUnit +
          parseFloat(d[5].v) * parseFloat(d[9].info.pricingBean.factor);
      }

      total = total + parseFloat(d[8].v);

      tax = tax + parseFloat(d[7].v);
      discount = discount + parseFloat(d[9].info.discountAmount);
    }

    setTotal(
      PricingUtils.formatPriceAfterRounding(
        total,
        props.context.store.currencyDecimal,
        props.saleSetting ? props.saleSetting.enableRoundoffSaleAmount : null,
        props.saleSetting ? props.saleSetting.roundOffFactor : null
      )
    );

    setTotalWithoutRounding(
      PricingUtils.formattedNumber(total, props.context.store.currencyDecimal)
    );

    setTotalAfterSubTotalDIscount(
      PricingUtils.formatPriceAfterRounding(
        total,
        props.context.store.currencyDecimal,
        props.saleSetting ? props.saleSetting.enableRoundoffSaleAmount : null,
        props.saleSetting ? props.saleSetting.roundOffFactor : null
      )
    );

    if (Number.isInteger(qty)) {
      setQty(qty);
    } else {
      setQty(PricingUtils.formattedNumber(qty, 3));
    }

    setQtyInBaseUnit(
      PricingUtils.formattedNumber(
        qtyInBaseUnit,
        props.context.store.currencyDecimal
      )
    );
    setNoItems(itemsSet.size);
    setDiscount(
      PricingUtils.formattedNumber(
        discount,
        props.context.store.currencyDecimal
      )
    );
    setTax(
      PricingUtils.formattedNumber(tax, props.context.store.currencyDecimal)
    );

    setAmountExTax(
      PricingUtils.formattedNumber(
        total - tax,
        props.context.store.currencyDecimal
      )
    );
    if (props.data.length == 0) {
      if (props.poleDisplayHandler) {
        props.poleDisplayHandler(null, null);
      }
    } else {
      let msg1 = " ";
      if (selectedRow) {
        msg1 = PoleDisplayUtils.prepareValue(
          selectedRow[2].v,
          selectedRow[8].v
        );
      }
      let showTotal =
        props.saleSetting && props.saleSetting.enableRoundoffSaleAmount
          ? false
          : true;
      if (props.poleDisplayHandler)
        props.poleDisplayHandler(
          msg1,
          PoleDisplayUtils.prepareValue(
            showTotal ? "Total:" : "",
            showTotal
              ? PricingUtils.formattedNumber(
                  total,
                  props.context.store.currencyDecimal
                )
              : ""
          )
        );
    }
  }, [props.data]);

  let mobileContent = (
    <div
      style={{
        paddingBottom: 5,
      }}
    >
      <Card>
        <Grid
          container
          style={{ background: teal[800], color: "#fff", padding: 3 }}
        >
          <Grid item xs={6} style={{ background: teal[800], color: "#fff" }}>
            <Typography
              variant="h8"
              style={{
                paddingLeft: 10,
                paddingTop: 10,
                textAlign: "left",
              }}
            >
              {translate("Total")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            style={{ background: teal[800], color: "#fff", textAlign: "right" }}
          >
            <Typography
              variant="h8"
              style={{
                paddingRight: 10,
                paddingTop: 10,
              }}
            >
              {total} {props.context.store.currency}
            </Typography>
          </Grid>
          <Grid item xs={6} style={{ background: teal[800], color: "#fff" }}>
            <Typography
              variant="h8"
              style={{
                paddingLeft: 10,
                paddingTop: 10,
                textAlign: "left",
              }}
            >
              {translate("After Discount")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            style={{ background: teal[800], color: "#fff", textAlign: "right" }}
          >
            <Typography
              variant="h8"
              style={{
                paddingRight: 10,
                paddingTop: 10,
                textAlign: "right",
              }}
            >
              {totalAfterSubtotalDiscount} {props.context.store.currency}
            </Typography>
          </Grid>
        </Grid>
      </Card>
    </div>
  );

  let desktopContent = (
    <Grid
      container
      style={{ height: "100%", background: teal[800], color: "#fff" }}
    >
      <Grid item xs={7}>
        <Grid container>
          <Grid item xs={12} style={{ background: teal[800], color: "#fff" }}>
            <Typography
              variant="h5"
              style={{ paddingLeft: 15, paddingTop: 10 }}
            >
              {translate("Summary")}
            </Typography>
          </Grid>
          <Grid item xs={12} style={{ height: "100%" }}>
            <table style={{ width: "100%", height: "100%", paddingLeft: 5 }}>
              <tbody style={{ width: "100%", height: "100%" }}>
                <tr>
                  <td style={{ paddingLeft: 10 }}>{translate("No Items")}</td>
                  <td
                    style={{
                      textAlign: "right",
                      paddingRight: 10,
                      fontWeight: "bold",
                    }}
                  >
                    {noItems}
                  </td>
                  <td>{translate("Quantity")}</td>
                  <td
                    style={{
                      textAlign: "right",
                      paddingRight: 10,
                      fontWeight: "bold",
                    }}
                  >
                    {qty}
                  </td>
                </tr>
                <tr>
                  <td style={{ paddingLeft: 10 }}>{translate("Tax")}</td>
                  <td
                    style={{
                      textAlign: "right",
                      paddingRight: 10,
                      fontWeight: "bold",
                    }}
                  >
                    {tax}
                  </td>
                  <td>{translate("Discount")}</td>
                  <td
                    style={{
                      textAlign: "right",
                      paddingRight: 10,
                      fontWeight: "bold",
                    }}
                  >
                    {discount}
                  </td>
                </tr>
                <tr>
                  <td style={{ paddingLeft: 10 }}>
                    {translate("Amount Ex Tax")}
                  </td>
                  <td
                    style={{
                      textAlign: "right",
                      paddingRight: 10,
                      fontWeight: "bold",
                    }}
                  >
                    {amountExTax}
                  </td>
                </tr>
              </tbody>
            </table>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={5}>
        <Grid container>
          <Grid item xs={12} style={{ background: teal[800], color: "#fff" }}>
            <Typography
              variant="h5"
              style={{
                paddingRight: 25,
                paddingTop: 20,
                textAlign: "right",
              }}
            >
              {translate("Total")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              textAlign: "right",
              background: teal[800],
              color: "#fff",
            }}
          >
            <Typography
              variant="h4"
              style={{
                paddingRight: 15,
                paddingTop: 15,
                color: "#fff",
                fontSize: "1.75rem",
              }}
            >
              {total} {props.context.store.currency}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );

  let serviceContent = (
    <Grid
      container
      style={{ height: "100%", background: teal[800], color: "#fff" }}
    >
      <Grid item xs={6} style={{ background: teal[800], color: "#fff" }}>
        <div
          style={{
            paddingLeft: 25,
            paddingTop: 10,
          }}
        >
          <Typography variant="h6">{translate("Total")}</Typography>
        </div>
      </Grid>
      <Grid item xs={6} style={{ background: teal[800], color: "#fff" }}>
        <div
          style={{
            textAlign: "right",
            paddingRight: 25,
            paddingTop: 10,
          }}
        >
          <Typography variant="h6">
            {total} {props.context.store.currency}
          </Typography>
        </div>
      </Grid>
    </Grid>
  );

  let tile_view_content = (
    <div
      style={{
        paddingBottom: 5,
      }}
    >
      <Card>
        <Grid
          container
          style={{ background: teal[800], color: "#fff", padding: 3 }}
        >
          <Grid item xs={6} style={{ background: teal[800], color: "#fff" }}>
            <Typography
              variant="h8"
              style={{
                paddingLeft: 10,
                paddingTop: 10,
                textAlign: "left",
              }}
            >
              {translate("No Items")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            style={{ background: teal[800], color: "#fff", textAlign: "right" }}
          >
            <Typography
              variant="h8"
              style={{
                paddingRight: 10,
                paddingTop: 10,
              }}
            >
              {noItems}
            </Typography>
          </Grid>

          <Grid item xs={6} style={{ background: teal[800], color: "#fff" }}>
            <Typography
              variant="h8"
              style={{
                paddingLeft: 10,
                paddingTop: 10,
                textAlign: "left",
              }}
            >
              {translate("Total Ex Tax")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            style={{ background: teal[800], color: "#fff", textAlign: "right" }}
          >
            <Typography
              variant="h8"
              style={{
                paddingRight: 10,
                paddingTop: 10,
              }}
            >
              {amountExTax}
            </Typography>
          </Grid>

          <Grid item xs={6} style={{ background: teal[800], color: "#fff" }}>
            <Typography
              variant="h8"
              style={{
                paddingLeft: 10,
                paddingTop: 10,
                textAlign: "left",
              }}
            >
              {translate("Tax")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            style={{ background: teal[800], color: "#fff", textAlign: "right" }}
          >
            <Typography
              variant="h8"
              style={{
                paddingRight: 10,
                paddingTop: 10,
              }}
            >
              {tax}
            </Typography>
          </Grid>
          <Grid item xs={6} style={{ background: teal[800], color: "#fff" }}>
            <Typography
              variant="h6"
              style={{
                paddingLeft: 10,
                paddingTop: 0,
                textAlign: "left",
              }}
            >
              {translate("Total")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            style={{ background: teal[800], color: "#fff", textAlign: "right" }}
          >
            <Typography
              variant="h6"
              style={{
                paddingRight: 10,
                paddingTop: 0,
              }}
            >
              {total} {props.context.store.currency}
            </Typography>
          </Grid>
        </Grid>
      </Card>
    </div>
  );

  function getContent() {
    if (props.context.appType === "R_POS") {
      return tile_view_content;
    }
    if (props.context.appMode === "desktop-pos") {
      if (props.saleType === "SERVICE") {
        return serviceContent;
      } else {
        if (props.terminalBean.saleMode == "TOUCH_POS_TILE") {
          return tile_view_content;
        } else {
          return desktopContent;
        }
      }
    } else {
      return mobileContent;
    }
  }

  return getContent();
}
